export default [
  {
    component: () => import('@/modules/appointments/views/AppointmentsIndex.vue'),
    name: 'index',
    path: '/appointments',
    meta: {
      requiresModule: 'appointments',
    },
  },
  {
    component: () => import('@/modules/appointments/views/AppointmentDetails.vue'),
    name: 'details',
    path: '/appointments/:appointmentId',
    meta: {
      requiresModule: 'appointments',
    },
  },
]
